import CategoryPage from '../components/CategoryPage/CategoryPage';
import Landing from '../components/Landing/Landing';
import { allSymbols } from '../data/symbolsData';

function Index() {
  return (
    <CategoryPage symbols={allSymbols} category="index">
      <Landing />
    </CategoryPage>
  );
}

export default Index;
